import { render, staticRenderFns } from "./Wp_pdd_skuinfo_poster.vue?vue&type=template&id=6c2e9b1c&scoped=true&"
import script from "./Wp_pdd_skuinfo_poster.vue?vue&type=script&lang=js&"
export * from "./Wp_pdd_skuinfo_poster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2e9b1c",
  null
  
)

export default component.exports